import React, { useState } from 'react';
import useStyle from './priceSlider.style';
import { useSelector, useDispatch } from 'react-redux';
import { AppState } from '../../../../store/reducers';
import { DialogContent } from 'components/molecules/Modal/DialogContent';
import { priceFilter } from '../../../../store/actions';

const PriceSlider = () => {
  const price = useSelector((state: AppState) => state.productFilter.price);
  const [localPrice, setLocalPrice] = useState(price.toString());
  const classes = useStyle({
    localPrice,
    left: (parseInt(localPrice) / 50) * 100,
    leftb: (parseInt(localPrice) / 50) * 81.5 + 1
  });
  const dispatch = useDispatch();

  const handleChange = () => {
    dispatch(priceFilter(localPrice));
  };

  return (
    <DialogContent dialogTitle="Prix">
      <input
        className={classes.slider}
        type="range"
        min="1"
        max="50"
        step={1}
        value={localPrice}
        onChange={e => {
          setLocalPrice(e.target.value);
        }}
        onMouseUp={handleChange}
        onTouchEnd={handleChange}
      ></input>
    </DialogContent>
  );
};

export default PriceSlider;
